import React from 'react'
import About from '../components/About/About'
import About1 from '../components/About1/About1'
import About2 from '../components/About2/About2'
import About3 from '../components/About3/About3'

const AboutUs = () => {
  return (
    <div className='abouts'>
        <About/>
        <About1/>
        <About2/>
        <About3/>
    </div>
  )
}

export default AboutUs